/*
|--------------------------------------------------------------------------
| Utilities: Fetch: View
|--------------------------------------------------------------------------
*/
/**
 * Fetch view should go under fetch handlebarsView...it's meant for getting a handlebars view based on data attributes
 * @memberof utilities.fetch
 * @namespace utilities.fetch.view
 * @inner
 */
__gh__webApp.utilities.fetch.view = {

	/**
	 * Initialize
	 *
	 * @memberof utilities.fetch.view
	 * @method init
	 */
	"init": function() {
		this.bindEvents();
	},

	/**
	 * Get data from a url, pass it to a view and put it into a dom container.
	 
	 * @memberof utilities.fetch.view
	 * @method get
	 * @param {object} options
	 * @param {string} options.url - json data url to fetch
	 * @param {string} options.dom - html dom to insert data
	 * @param {string} options.view - name of handlebars view
	 * @param {boolean} [options.append] - true or false, append the data or replace it
	 * @param {string} [options.callbacks] - array of callback objects meant for &lowbar;&lowbar;gh&lowbar;&lowbar;webApp.common.callArrayOfFunctions
	 * @param {object} [options.data] - object of data to send to the view
	 * @example
	 *	&lt;a href="#"
	 *		data-gh-fetch-view-loaded="false"
	 *		data-gh-fetch-view-view="partialSlider3Image"
	 *		data-gh-fetch-view-dom="#gh-fetch-view-{{id}}"
	 *		data-gh-fetch-view-url="{{feedURL}}"
	 *		data-gh-fetch-view-callbacks="&lowbar;&lowbar;gh&lowbar;&lowbar;webApp.utilities.slider.bindEvents"
	 *		data-gh-fetch-view-data='{"id":"{{id}}"}'
	 *	&gt;{{title}}&lt;/a&gt;
	 */
	 "get": function(options){
		var url 					= (options.url) 			? options.url 				: null,
			dom 					= (options.dom) 			? options.dom 				: null,
			view 					= (options.view) 			? options.view 				: null,
			append 					= (options.append)			? options.append			: false,
			callbacks 				= (options.callbacks)		? options.callbacks			: null,
			additionalData			= (options.data)			? options.data				: null;

		//Check variables
		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing dom."});
			return;
		}
		if(!view){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Missing view."});
			return;
		}


		//Get JSON
		var data = {"items": __gh__webApp.utilities.fetch.json.get({"url":url})};
		if(!data.items.main){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Getting the data failed."});
			return;
		}


		//Merge data
		if (data){
			data = __gh__webApp.common.mergeObjects(data,additionalData);
		}


		//Get View
		var html = __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});
		if(!html){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.view.get",message:"Getting the view failed."});
			return;
		}


		//Insert Into DOM
		if(append){
			$(dom).append(html);

		}
		else{
			$(dom).html(html);
		}

		//Run callback function
		if (callbacks){
			__gh__webApp.common.callArrayOfFunctions(callbacks);
		}

	},


	/**
	 * Loads views on a page based on the view data object
	 *
	 * @memberof utilities.fetch.view
	 * @method loadAllViews
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 * @param {string} options.view - view name to use
	 * @param {object} options.data - data for the view
	 * @example
	 * &lt;div id="example" data-gh-fetch-view-loaded="false" data-gh-fetch-view-object='{"url":"http://example.com/json","view":"viewName","data":"data"}'&gt;&lt;/div&gt;
	 */
	 "loadAllViews": function() {
		var fetchView = this.get;
		//Auto load html content
		$("[data-gh-fetch-view-loaded=false]").each(function(){
			var $this 			= $(this);
				fetchViewObject = $this.data("gh-fetch-view-object");

			if (!fetchViewObject.dom){
				fetchViewObject.dom = $this[0];
			}

			fetchView(fetchViewObject);

			//Only load html once.
			if(!$dom.data("gh-fetch-view-loaded")){
				$dom.attr("data-gh-fetch-view-loaded",true);
			}


	  	});
	},


	/**
	 * Load a lazy view
	 * @memberof utilities.fetch.view
	 * @method loadLazyView
	 */
	"loadLazyView": function(){
		var thisObject = __gh__webApp.utilities.fetch.view,
			$lazyView = $("[data-gh-fetch-lazy-view-loaded=false]").first(),
			lazyViewObject;

		//Check to see if is on screen
		if ($lazyView.length && $lazyView.isOnScreen(500)){

	    	lazyViewObject = $lazyView.data("gh-fetch-view-object");
	    	
	    	thisObject.get(lazyViewObject);
	    	
			$lazyView.attr("data-gh-fetch-lazy-view-loaded",true);
	    }
	},


	/**
	 * Bind the UI events
	 *
	 * @memberof utilities.fetch.view
	 * @method bindEvents
	 */
	"bindEvents": function() {
		var fetchView = this.get;

	    $(document).on("click", "a[data-gh-fetch-view-object]", function(event){
		    event.preventDefault();
		    var fetchViewObject = $(this).data("gh-fetch-view-object");
			fetchView(fetchViewObject);
		});

	    $(document).on("scroll.gh-fetch-lazy-views",this.loadLazyView);

  	},
};
